import React from "react";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";

export default function NodeNewsTermsFilter({ terms, current = null }) {
  const { t } = useTranslation("common");

  return (
    <ul className="flex flex-wrap items-center justify-start lg:justify-end gap-4 lg:gap-8">
      <li>
        {current === null ? (
          <span className="text-primary uppercase">{t("utils.all")}</span>
        ) : (
          <Link href={t("news.path")} scroll={false} passHref>
            <a className="text-white uppercase underline underline-offset-4 transition-colors hover:decoration-primary">
              {t("utils.all")}
            </a>
          </Link>
        )}
      </li>
      {terms.map((term) => {
        return (
          <li key={term.id}>
            {current && current.id === term.id ? (
              <span className="text-primary uppercase">{term.name}</span>
            ) : (
              <Link href={term.path.alias} scroll={false} passHref>
                <a className="text-white uppercase underline underline-offset-4 transition-colors hover:decoration-primary">
                  {term.name}
                </a>
              </Link>
            )}
          </li>
        );
      })}
    </ul>
  );
}
